import CellularTemplate from './cellular.html';

export default angular
  .module('main.devices.edit.tabs.cellular', [])

  .directive('editDeviceCellularTab', () => {
    return {
      restrict: 'E',
      template: CellularTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   utils,
                   EditDeviceDataProvider,
                   I18nService) => {
        const $t = $filter('translate');
        $scope.timeFormatStr = $t('datetime.mdyHM12');

        $scope.dataProvider = EditDeviceDataProvider.instance;
        $scope.locale = I18nService.getLocale();
        $scope.loading = true;

        angular.extend($scope, {
          onBackButtonClick: onBackButtonClick,
          copyToClipboard: $rootScope.copyToClipboard,
          formatBytes: formatBytes,
          activateSim: activateSim,
        });

        init();

        function init() {
          $q.all([
            $scope.dataProvider.deviceCurrentMeasurementsResource.init(),
            $scope.dataProvider.deviceParametersResource.init(),
            $scope.dataProvider.deviceModelResource.init(),
            $scope.dataProvider.simCardsResource.init(),
            $scope.dataProvider.deviceResource.init(),
          ])
            .then(() => {
              initWatchers();
              $scope.loading = false;
            });
        }

        function initWatchers() {
          $scope.$watchGroup([
            'dataProvider.deviceCurrentMeasurementsResource.value',
            'dataProvider.simCardsResource.value'
          ], () => {
            initViewModel();
          });
        }

        function initViewModel() {
          const measurements = angular.copy($scope.dataProvider.deviceCurrentMeasurementsResource.value?.parameters || []);
          const deviceParams = angular.copy($scope.dataProvider.deviceParametersResource.value || []);
          const simCards = angular.copy($scope.dataProvider.simCardsResource.value || []);
          const deviceModel = $scope.dataProvider.deviceModelResource.value;

          if (!measurements || !deviceParams) {
            return;
          }

          // Mapper for device parameter naming
          const deviceParamsMap = deviceParams.reduce((acc, p) => {
            if (p.name) {
              acc[p.name] = p;

              // Merge display info from device parameter and device model
              if (deviceModel) {
                const deviceModelDisplayInfo = (deviceModel.displayInfo && deviceModel.displayInfo.parameters)
                  ? deviceModel.displayInfo.parameters.find(param => param.name === p.name)
                  : {};
                p.displayInfo = angular.extend(p.displayInfo || {}, deviceModelDisplayInfo);
              }
            }
            return acc;
          }, {});

          // Gather info about SIM cards and cellular connection
          const currentApn = measurements.find(el => el.name === 'ccidIndex');
          const currentApnIndex = currentApn && parseInt(currentApn.value);
          const currentSim = {
            index: currentApnIndex ? currentApnIndex : 0
          };
          const cellularInfo = {
            apns: [],
            apnIndex: currentApnIndex
          };

          measurements.forEach(el => {
            // General Cellular information
            if (el.name === 'mobileState') {
              el.desc = parameterValueToStr(deviceParamsMap[el.name], el.value, el.index);
              cellularInfo.mobileState = el;
            }
            if (el.name === 'mobileRegistration') {
              cellularInfo.mobileRegistration = el.value;
            }
            if (el.name === 'mobileAccessTechnology') {
              cellularInfo.mobileAccessTechnology = el.value;
            }
            if (el.name === 'imei') {
              cellularInfo.imei = el.value;
            }
            if (el.name === 'mobileSignal') {
              cellularInfo.mobileSignal = parseInt(el.value);
              $scope.mobileSignalIcon = utils.getDeviceParameterIcon(
                deviceParams.find(p => p.name === 'mobileSignal'),
                el.value
              );
            }

            // SIM cards information
            if (el.name === 'ccid') {
              currentSim.ccid = el.value;
            }
            if (el.name === 'apn') {
              el.index = parseInt(el.index);
              el.value = parameterValueToStr(deviceParamsMap[el.name], el.value, el.index);
              cellularInfo.apns.push(el);
              if (el.index === currentSim.index) {
                currentSim.apn = el.value;
                currentSim.lastUpdateTime = el.lastUpdateTime;
                currentSim.lastUpdateTimeMs = el.lastUpdateTimeMs;
                cellularInfo.mobileApn = el.value;
              }
            }
          });

          const currentSimIndex = simCards.findIndex(el => el.id === currentSim.ccid);

          // Enrich SIM cards data model (assuming not more than two SIMs)
          if (currentSimIndex >= 0) {
            Object.assign(simCards[currentSimIndex], currentSim);
          } else {
            simCards.push(currentSim);
          }

          // For more than one APNs (SIM slots)
          if (cellularInfo.apns.length > 1) {
            cellularInfo.apns.forEach(el => {
              if (el.index !== currentApnIndex) { // Exclude current SIM

                const apnInfo = {
                  index: el.index,
                  apn: el.value,
                  lastUpdateTime: el.lastUpdateTime,
                  lastUpdateTimeMs: el.lastUpdateTimeMs
                };

                if (simCards.length > 1) { // If 2nd SIM was activated previously
                  let secondSimIndex = currentSimIndex === 0 ? 1 : 0;
                  Object.assign(simCards[secondSimIndex], apnInfo);
                } else {
                  simCards.push(apnInfo);
                }
              }
            });
          }

          $scope.cellularInfo = cellularInfo;
          $scope.simCards = simCards.sort((a, b) => a.index - b.index);
          $scope.isBalance = simCards.some(el => el.balanceDate);
        }

        function activateSim(sim) {
          // Only activation for now (do not deactivate)
          if ($scope.loading || !sim || !sim.id || sim.status !== 0 || sim.status !== 5) {
            return;
          }

          $scope.dataProvider.activateSimCard(sim);
        }

        function parameterValueToStr(parameter, value, index) {
          return utils.deviceParameterToString(parameter, value, index, $scope.locale.code);
        }

        function formatBytes(bytes) {
          return utils.formatBytes(bytes);
        }

        function onBackButtonClick() {
          $scope.dataProvider.activeTab = 'summary';
        }
      }
    };
  })
  .name;
